import {DatePipe, JsonPipe} from '@angular/common';
import {Component, OnInit} from '@angular/core';
import {MatCheckbox} from '@angular/material/checkbox';
import {MatChip} from '@angular/material/chips';
import {MatDivider} from '@angular/material/divider';
import {MatAccordion, MatExpansionPanel, MatExpansionPanelHeader, MatExpansionPanelTitle} from '@angular/material/expansion';
import {CargoModel} from '../../../models/products.model';
import {ProductionService} from '../../../services/production.service';
import {AlertService} from '../../../services/notify/alert.service';

@Component({
    selector: 'app-cargo-list',
    standalone: true,
    imports: [
        MatAccordion,
        MatExpansionPanel,
        MatExpansionPanelTitle,
        MatCheckbox,
        MatExpansionPanelHeader,
        DatePipe,
        MatChip,
        MatDivider,
    ],
    templateUrl: './cargo-list.component.html',
    styleUrl: './cargo-list.component.scss'
})
export class CargoListComponent implements OnInit {

    public checkedAccordion = [];

    public allCargos: CargoModel[];

    constructor(
        private productionService: ProductionService,
        private alertService: AlertService,
    ) {
    }

    ngOnInit(): void {
        this.getAllCargos();
    }

    getAllCargos(): void {
        this.productionService.getAllCargos().subscribe({
            next: res => {
                this.allCargos = res.cargos;
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    createCargo() {
        this.productionService.createCargo().subscribe({
            next: res => {
                this.getAllCargos();
                console.log(res);
            }, error: err => {
                this.alertService.setAlert(err.message, 'blue');
            }
        });
    }

    checkAccordion(index: number, checked: boolean): void {
        this.checkedAccordion[index] = checked;
    }

    addCargosToTransaction(): void {
        const cargoKeys: string[] = [];

        this.allCargos.forEach((cargo: CargoModel, index: number) => {
            if (this.checkedAccordion[index]) {
                cargoKeys.push(cargo.ps_cargo_key);
            }
        });

        this.productionService.addCargosToTransaction(cargoKeys.toString()).subscribe({
            next: res => {
                console.log(res);
                this.checkedAccordion = this.checkedAccordion.map(() => {
                    return false;
                });

            }, error: err => {
                this.alertService.setAlert(err.mesage, 'blue');
            }
        });
    }
}
